export default {
  aboutFirstPart: `Com mais de 35 anos de experiência em camisas, calças e ternos sob medida,
  possuímos profissionais experientes e altamente qualificados.`,
  aboutSecondPart: `Cada cliente tem seu molde exclusivamente desenvolvido para seu biotipo
  através das medidas tiradas pelo próprio Sr. Renee,
  no escritório ou residência do cliente.`,
  aboutCitation: `"Nosso objetivo é superar a expectativa do cliente proporcionando-lhe
  satisfação ao usar nossos produtos, aliado a um relacionamento franco e honesto,
  valorizando o ser humano."`,
  highlight: '“Faço roupas com o Renee Trajar há mais de duas décadas, o serviço é impecável em todos os detalhes, desde a  costura ao caimento. O Renee tem uma equipe de mestre!”',
};
